import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LocalStorageService } from "angular-2-local-storage";
import * as d3 from 'd3';
import * as moment from 'moment/moment';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DistributorIdFormatPipe } from "../../common/pipes/distributor-id-format.pipe";
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { DownlineMemberLevel } from '../../shared/constants/common.constants';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { Utils } from '../../shared/Utils/utils';
import { MemberTypeConstants } from '../constants/memberlevel-type.constants';
import { CountryList } from '../interface/country-data';
import { CustomerService } from '../services/customer.service';
import { DateConstants } from '../constants/date.constants';



@Component({
    selector: 'app-downline-map',
    templateUrl: '../templates/template1/views/downline-map.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/downline-map.component.less'
    ],
    providers: [DistributorIdFormatPipe, DecimalPipe]

})
export class DownlineMapComponent implements OnInit {
    @Input() fboid: string;
    @Input() homeCountryInfo: string;
    @Input() distributorInfo: string;
    width = (window.screen.width);
    memberName: string;
    largeScreen = false;
    selectedOption: boolean;
    country: string;
    updatedEvent: any;
    id: string;
    mobile: boolean;
    searchText: any = "";
    tempData: any = [];
    globalLeftOffset = 0;
    isSearchTextAvailable = false;
    globalTopOffset = 0;
    profilePicUrl: string;
    noImageUrl: string;
    mydate: string;
    monthlyCCValues: any = [];
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    showDatePicker = true;
    downlineMapForm: FormGroup;
    selectedCountry: any = [];
    verticalTreeRequest: Subscription;
    countries: CountryList[] = [];
    _id: string;
    userName: string;
    middleName: string;
    distributorId: string;
    isHierarchyAvailable: boolean = false;
    flag: Boolean = false;
    homeCountry: any = [];
    pathIdList: any = [];
    treeData: any = [];
    treeDataCCValues: any = [];
    userInfo: any;
    month: any = [];
    isDetailsOpened = false;
    selectedDistributorName = "";
    isScrollToSearch: Boolean = false;
    downlineIds: Array<string> = [];
    cookieService: CookieService = new CookieService(document);
    selectedMemberLevel = 1;
    showNonZero = true;
    searchflag = false;
    memberTypeConstants = MemberTypeConstants;
    profile: any =
        {
            url: this.noImageUrl, name: "",
            level: "", id: "", contact: { email: "", mobile: "" }
        };
    volume = { personalCCMtd: "0", personalCCYtd: "0", nonManagerCC: "0", nmCCYtd: "0", fboCCMtd: "0", fboCCYtd: "0", totalActiveCCMtd: "0", totalActiveCCYtd: "0", totalCCYtd: "0", totalCCMtd: "0", totalCC2Mtd: "0" };
    globalRally = { globalRallyCC: "0 ", globalRallyLevel: "-", ccToNextLevel: "0" };
    eagleManager = { homeCountryTotalCC: "0", eagleHomeNewNMCC: "0", eagleNonHomeNewNMCC: "0", newEagleManagerGlobalCC: "0", potentialEagleManagersActual: "0", numberofNewSupervisors: "0", potentialEagleManagersRequired: "0" };
    chairmansBonus = { homePersonalNMCC: "0", chairmanHomeNewNMCC: "0", chairmanNonHomeNewNMCC: "0", potentialManagers: "0", potential600CCManagers: "0", newChairmansBonusGlobalCC: "0" };
    forever2Drive = {
        forever2DriveStatus: "0", forever2Drivelevel: "0", forever2DriveQualDate: "", forever2DriveExpirationDate: "", forever2DriveReQualificationStartDate: ""
    };
    leadershipBonus = { isRecognizedManager: "-", numberofLeadershipManagers: "0", isLeadershipQualified: "-", leadershipBonusCCActual: "0", leadershipBonusCCRequired: "0" };
    gemBonus = { firstGenActiveManagerscount: "0" };
    errormessage: boolean;
    constructor(
        private messageService: MessageService,
        private _commonService: CommonService,
        private _datePipe: DatePipe,
        private _formbuilder: FormBuilder,
        private _cacheService: CacheService,
        private _decimalPipe: DecimalPipe,
        private _distributorIdFormatPipe: DistributorIdFormatPipe,
        private _localStorageService: LocalStorageService,
        private _customerService: CustomerService
    ) { }

    ngOnInit(): void {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this._id = this.fboid;
        this.distributorId = this.fboid;
        this.memberName = this.distributorInfo;
        this.mydate = this._datePipe.transform(new Date(), 'dd-MMM-yyyy');
        this.userName = this.userInfo['firstName'] + " " + this.userInfo['lastName'];
        this.country = this.homeCountryInfo;
        this.downlineMapForm =
            this._formbuilder.group({
                fromDate: '',
                toDate: ''
            })
        if (this.homeCountryInfo != "" && this.homeCountryInfo != null) {
            this.getCountries(this._id, this.country);
        }
        this.getLastThreeMonths();
    }
    setScreen(width: any) {
        this.width = width;
        if (this.width > 1200) {
            this.largeScreen = true;
        }
        else {
            this.largeScreen = false;
        }
    }
    onResize(event: any): void {
        const innerWidths = event.target.innerWidth;
        this.setScreen(innerWidth);
    }

    /**
   * changeCountry Method used to get the downlines data based on country selected
   * @param  {string} country
   * @returns void
   */
    changeCountry(country: string): void {
        this.isDetailsOpened = false;
        this.country = country;
        this.selectedOption = false;
        this.searchText = '';
        this.isHierarchyAvailable = false;
        this.flag = false;
        let fromDate = Utils.convertToSpecificDateFormat(this.downlineMapForm.controls['fromDate'].value, DateConstants.DOBFormat);
        let toDate = Utils.convertToSpecificDateFormat(this.downlineMapForm.controls['toDate'].value, DateConstants.DOBFormat);
        this.getVerticalTreeData(this.fboid, this.country, this.selectedMemberLevel, fromDate, toDate, this.showNonZero);
    }

    getLastThreeMonths() {
        let currentMonth = new Date().getMonth() + 1;
        this.month.push(moment((currentMonth - 2) === 0 ? 12 : (currentMonth - 2) === -1 ? 11 : (currentMonth - 2), 'MM' || 'M').format('MMMM'));
        this.month.push(moment((currentMonth - 1) === 0 ? 12 : (currentMonth - 1), 'MM' || 'M').format('MMMM'));
        this.month.push(moment(currentMonth, 'MM' || 'M').format('MMMM'));
    }

    /**
    * getCountries Method used to get the country list
    * @param  {number} distributorId
    * @returns void
    */
    getCountries(distributorId: string, homeCountryInfo: string): void {
        this._commonService
            .getCountries(distributorId, homeCountryInfo)
            .subscribe(res => {
                if (res) {
                    res.forEach((element: any) => {
                        let country: CountryList = { name: '', value: '' };
                        country.name = element.countryName;
                        country.value = element.operatingCompany;
                        if (element.homeCountry === true || element.homeCountry === 'true') {
                            this.selectedCountry = country;
                            this.country = this.selectedCountry.value;
                        }
                        this.countries.push(country);
                    }
                    );
                    let fromDate = '';
                    let toDate = '';

                    if (this.downlineMapForm.controls['fromDate'].value && this.downlineMapForm.controls['toDate'].value) {
                        fromDate = Utils.convertToSpecificDateFormat(this.downlineMapForm.controls['fromDate'].value, DateConstants.DOBFormat);
                        toDate = Utils.convertToSpecificDateFormat(this.downlineMapForm.controls['toDate'].value, DateConstants.DOBFormat);
                    }
                    this.getVerticalTreeData(this.fboid, this.country, this.selectedMemberLevel, fromDate, toDate, this.showNonZero);
                }
            },
                error => {
                    this.errormessage = true;
                    console.error(error);
                });
    }

    onFocus() {
        if (this.searchText != "" && this.isHierarchyAvailable == true) {
            this.isHierarchyAvailable = true;
            this.flag = false;
        }
        else {
            this.isHierarchyAvailable = false;
        }
    }

    onFocusOut() {
        this.isHierarchyAvailable = false;
    }

    getdetailsByMemberLevel() {
        let fromDate = '';
        let toDate = '';
        this.searchText = '';
        this.isHierarchyAvailable = false;
        this.flag = false;
        if (this.downlineMapForm.controls['fromDate'].value && this.downlineMapForm.controls['toDate'].value) {
            fromDate = Utils.convertToSpecificDateFormat(this.downlineMapForm.controls['fromDate'].value, DateConstants.DOBFormat);
            toDate = Utils.convertToSpecificDateFormat(this.downlineMapForm.controls['toDate'].value, DateConstants.DOBFormat);
        }

        this.getVerticalTreeData(this.fboid, this.country, this.selectedMemberLevel, fromDate, toDate, this.showNonZero);
    }

    transformFromDate(date: any) {
        let fromDate = null;
        if(date){
            fromDate = Utils.convertToSpecificDateFormat(date, DateConstants.DOBFormat)
        }
        if (fromDate) {
            if (this.downlineMapForm.controls['fromDate'].valid) {
                this.downlineMapForm.controls['fromDate'].setValue(moment(fromDate, 'YYYY-MM-DD'));                
            }
        }
        else{
            this.downlineMapForm.controls['fromDate'].setValue('');
        }
    }
    transformToDate(date: any) {
        let toDate = null;
        if(date){
            toDate = Utils.convertToSpecificDateFormat(date, DateConstants.DOBFormat);
        }
        if (toDate) {
            if (this.downlineMapForm.controls['toDate'].valid) {
                this.downlineMapForm.controls['toDate'].setValue(moment(toDate, 'YYYY-MM-DD'));
            }
        }
        else{
            this.downlineMapForm.controls['toDate'].setValue('');
        }
    }

    showFilteredDownlineMembers(showNonZero: boolean) {
        let fromDate = '';
        let toDate = '';
        this.searchText = '';
        this.isHierarchyAvailable = false;
        this.flag = false;
        if (this.downlineMapForm.controls['fromDate'].value && this.downlineMapForm.controls['toDate'].value) {
            fromDate = Utils.convertToSpecificDateFormat(this.downlineMapForm.controls['fromDate'].value, DateConstants.DOBFormat);
            toDate = Utils.convertToSpecificDateFormat(this.downlineMapForm.controls['toDate'].value, DateConstants.DOBFormat);
        }
        this.showNonZero = !showNonZero;
        this.getVerticalTreeData(this.fboid, this.country, this.selectedMemberLevel, fromDate, toDate, this.showNonZero);
    }

    search(): any {
        let fboId = "";
        var fName = "";
        var lName = "";
        this.flag = false;
        this.searchflag = false;
        let fromDate = '';
        let toDate = ''
        this.isHierarchyAvailable = false;
        this.isDetailsOpened = false;
        this.isSearchTextAvailable = true;
        
        if (this.downlineMapForm.controls['fromDate'].value && this.downlineMapForm.controls['toDate'].value) {
            fromDate = Utils.convertToSpecificDateFormat(this.downlineMapForm.controls['fromDate'].value, DateConstants.DOBFormat);
            toDate = Utils.convertToSpecificDateFormat(this.downlineMapForm.controls['toDate'].value, DateConstants.DOBFormat);            
        }
        
        if(!this.searchText){
            this.getVerticalTreeData(this.fboid, this.country, this.selectedMemberLevel, fromDate, toDate, this.showNonZero);
        }

        if (this.searchText && this.searchText !== '') {

            if (this.searchText.match(/^[\d-\s]+$/)) {
                fboId = this.searchText.replace(/-/g, '').trim();
            } else if (this.searchText.split(' ').length >= 2) {
                fName = this.searchText.substring(0, this.searchText.lastIndexOf(' ')).trim();
                lName = this.searchText.substring(this.searchText.lastIndexOf(' ')).trim();
            } else {
                this.flag = true;
                // this._loader.hide();
            }

            if (fboId != "" || (fName != "" && lName != "")) {
                this._commonService.getSearchList(fboId, fName, lName, this.country, this.fboid)
                    .subscribe((res: any) => {
                        if (res.length > 0) {
                            this.pathIdList = res;
                            this.isHierarchyAvailable = true;
                            this.flag = false;
                        }
                        else {
                            this.isHierarchyAvailable = false;
                            this.flag = true;
                        }

                        // this._loader.hide();
                    },
                        (error: any) => {
                            this.errormessage = true;
                            console.error(error);
                        });
            }
        }
        this.isSearchTextAvailable = false;
    }

    reset() {
        // this.getCountries(this._id, this.homeCountryInfo);
        this.searchText = "";
        this.downlineIds = [];
        this.selectedDistributorName = "";
        // this.selectedMemberLevel = 1;
        this.flag = false;
        this.downlineMapForm.controls['toDate'].setValue('');
        this.downlineMapForm.controls['fromDate'].setValue('');
        // this.showNonZero = true;
        this.isScrollToSearch = false;
        this.isHierarchyAvailable = false;
        this.getVerticalTreeData(this.fboid, this.country, this.selectedMemberLevel, '', '', this.showNonZero);
    }

    toggleDetailsPane() {
        if (this.isDetailsOpened) {
            this.isDetailsOpened = false;
        }
        else {
            this.isDetailsOpened = true;
            if (this.id) {
                this._id = this.id;
            }
            this.getVerticalTreeCCValues(this._id, this.country);
        }
    }

    assignVolumeDetails() {
        return {
            personalCCMtd: this.treeDataCCValues.monthlyCCValues[0].personalCCMTD = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].personalCCMTD),
            personalCCYtd: this.treeDataCCValues.personalCC = this.totalCCValues(this.treeDataCCValues.personalCC),
            nonManagerCC: this.treeDataCCValues.monthlyCCValues[0].nonManagerCCMTD = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].nonManagerCCMTD),
            nmCCYtd: this.treeDataCCValues.nonManagerCC = this.totalCCValues(this.treeDataCCValues.nonManagerCC),
            fboCCMtd: this.treeDataCCValues.monthlyCCValues[0].distributorCCMTD = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].distributorCCMTD),
            fboCCYtd: this.treeDataCCValues.distributorCC = this.totalCCValues(this.treeDataCCValues.distributorCC),
            totalActiveCCMtd: this.treeDataCCValues.monthlyCCValues[0].totalActiveCCMTD = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].totalActiveCCMTD),
            totalActiveCCYtd: this.treeDataCCValues.totalActiveCC = this.totalCCValues(this.treeDataCCValues.totalActiveCC),
            totalCCYtd: this.treeDataCCValues.totalCC = this.totalCCValues(this.treeDataCCValues.totalCC),
            totalCCMtd: this.treeDataCCValues.monthlyCCValues[0].totalCCMTD = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].totalCCMTD),

            totalCC2Mtd: this.treeDataCCValues.monthlyCCValues[0].totalCC2MTD = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].totalCC2MTD)
        }
    }

    assignEagleManagerDetails() {
        return {
            homeCountryTotalCC: this.treeDataCCValues.monthlyCCValues[0].eagleManagerTotalCC = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].eagleManagerTotalCC),
            eagleHomeNewNMCC: this.treeDataCCValues.monthlyCCValues[0].homeCountryEagleManagerCC = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].homeCountryEagleManagerCC),
            eagleNonHomeNewNMCC: this.treeDataCCValues.monthlyCCValues[0].nonHomeCountryEagleManagerCC = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].nonHomeCountryEagleManagerCC),
            newEagleManagerGlobalCC: this.treeDataCCValues.newEagleManagerGlobalCC = this.totalCCValues(this.treeDataCCValues.newEagleManagerGlobalCC),
            potentialEagleManagersActual: this.treeDataCCValues.monthlyCCValues[0].numberOfEagleManagers ? this.treeDataCCValues.monthlyCCValues[0].numberOfEagleManagers : "0",
            potentialEagleManagersRequired: this.treeDataCCValues.monthlyCCValues[0].numberOfEagleManagersRequired ? this.treeDataCCValues.monthlyCCValues[0].numberOfEagleManagersRequired : "0",
            numberofNewSupervisors: this.treeDataCCValues.monthlyCCValues[0].numberOfNewsupervisors ? this.treeDataCCValues.monthlyCCValues[0].numberOfNewsupervisors : "0"
        }
    }

    assignChairmanBonusDetails() {
        return {
            homePersonalNMCC: this.treeDataCCValues.monthlyCCValues[0].chairmansBonusPersonalNonmanagerCC = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].chairmansBonusPersonalNonmanagerCC),
            chairmanHomeNewNMCC: this.treeDataCCValues.monthlyCCValues[0].homeCountryChairmansBonusCC = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].homeCountryChairmansBonusCC),
            chairmanNonHomeNewNMCC: this.treeDataCCValues.monthlyCCValues[0].nonHomeCountryChairmansBonusCC = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].nonHomeCountryChairmansBonusCC),
            potentialManagers: this.treeDataCCValues.potentialManagers ? this.treeDataCCValues.potentialManagers : "0",
            potential600CCManagers: this.treeDataCCValues.monthlyCCValues[0].numberOfDownlineManagersWith600CC = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].numberOfDownlineManagersWith600CC),
            newChairmansBonusGlobalCC: this.treeDataCCValues.monthlyCCValues[0].globalChairmansBonus = this.totalCCValues(this.treeDataCCValues.monthlyCCValues[0].globalChairmansBonus)
        }
    }

    assignForeverDetails() {
        return {
            forever2DriveStatus: this.treeDataCCValues.forever2DriveStatus ? this.treeDataCCValues.forever2DriveStatus : "--",
            forever2Drivelevel: this.treeDataCCValues.monthlyCCValues[0].earnedIncentivelevel ? this.treeDataCCValues.monthlyCCValues[0].earnedIncentivelevel : "--",
            forever2DriveQualDate: this.treeDataCCValues.monthlyCCValues[0].earnedIncentiveQualificationDate ? this.treeDataCCValues.monthlyCCValues[0].earnedIncentiveQualificationDate : "--",
            forever2DriveExpirationDate: this.treeDataCCValues.monthlyCCValues[0].earnedIncentiveExpirationDate ? this.treeDataCCValues.monthlyCCValues[0].earnedIncentiveExpirationDate : "--",
            forever2DriveReQualificationStartDate: this.treeDataCCValues.monthlyCCValues[0].earnedRequalificationStartDate ? this.treeDataCCValues.monthlyCCValues[0].earnedRequalificationStartDate : "--"
        }
    }

    assignLeadershipBonusDetails() {
        return {
            isRecognizedManager: this.treeData[0].recognizedManager == true ? "Yes" : "No",
            numberofLeadershipManagers: this.treeDataCCValues.monthlyCCValues[0].numberOfLeadershipManagers ? this.treeDataCCValues.monthlyCCValues[0].numberOfLeadershipManagers : "0",
            isLeadershipQualified: this.treeDataCCValues.monthlyCCValues[0].leadershipQualifiedFlag == true ? "Yes" : "No",
            leadershipBonusCCActual: this.treeDataCCValues.leadershipBonusCCActual ? this.treeDataCCValues.leadershipBonusCCActual : "0",
            leadershipBonusCCRequired: this.treeDataCCValues.leadershipBonusCCRequired ? this.treeDataCCValues.leadershipBonusCCRequired : "0"
        }
    }

    getVerticalTreeCCValues(distributorId: string, country: string): void {
        let countryCode = country && country !== "" ? country : this.homeCountryInfo;

        this.verticalTreeRequest = this._commonService
            .getVerticalTreeCCValues(distributorId, this.country)
            .subscribe(res => {

                this.treeDataCCValues = res === null ? [] : res[0];
                this.volume = this.assignVolumeDetails();
                this.eagleManager = this.assignEagleManagerDetails()
                this.chairmansBonus = this.assignChairmanBonusDetails();
                this.forever2Drive = this.assignForeverDetails();
                this.leadershipBonus = this.assignLeadershipBonusDetails();

                this.globalRally = {
                    globalRallyCC: this.treeDataCCValues.globalRallyCC,
                    globalRallyLevel: this.treeData[0].globalRallyLevel ? this.treeDataCCValues.globalRallyLevel : "-",
                    ccToNextLevel: this.treeDataCCValues.ccToNextLevel
                };

                this.gemBonus = { firstGenActiveManagerscount: this.treeDataCCValues.monthlyCCValues[0].numberOfDownlineGem1stGenArm ? this.treeDataCCValues.monthlyCCValues[0].numberOfDownlineGem1stGenArm : "0" };
            }
            );
    }

    /**
     *
     *
     * @param {number} ccValue
     * @returns
     * @memberof DownlineMapComponent
     */
    totalCCValues(ccValue: number) {

        let totalCCMonthValue;
        if (ccValue) {
            totalCCMonthValue = this._decimalPipe.transform(+(ccValue), '1.3-3');
        }
        else {
            totalCCMonthValue = '0.00';
        }
        return totalCCMonthValue;
    }

    /**
          * getVerticalTreeData Method used to get the downlione Data 
          * @param  {number} distributorId
          * @param  {string} country
          * @param  {number} year?
          * @returns void
          */
    getVerticalTreeData(distributorId: string, country: string, memberLevel: number, fromDate?: string, toDate?: string, showNonZero?: boolean): void {
        // this._loader.show();
        let countryCode = country && country !== "" ? country : this.homeCountryInfo;
        this.verticalTreeRequest = this._commonService
            .getVerticalTree(distributorId, this.country, memberLevel, fromDate, toDate, showNonZero)
            .subscribe(res => {
                this.treeData = res === null ? [] : res;
                if (this.treeData.length > 0) {
                    this.downlineIds.push(this.treeData[0].distributorId);
                    if (this.treeData[0].profileUrl == "" || this.treeData[0].profileUrl == null) {
                        this.profile = { url: this.noImageUrl, name: this.treeData[0].name, level: this.treeData[0].level, id: this.treeData[0].distributorFormatedId, contact: { email: this.treeData[0].email, mobile: this.treeData[0].phone } };
                        this.profilePicUrl = this.profile.url;
                    }
                    else {
                        this.profile = { url: this.treeData[0].profileUrl, name: this.treeData[0].name, level: this.treeData[0].level, id: this.treeData[0].distributorFormatedId, contact: { email: this.treeData[0].email, mobile: this.treeData[0].phone } };
                        this.profilePicUrl = this.profile.url;
                    }

                    if(this.treeData[0].children.length == 0) {
                        this.searchflag = true;
                    }
                    else{
                        this.searchflag = false;
                    }

                    this.drawCollapisibleTree(this.treeData[0]);

                } 
            },
                error => {
                    this.errormessage = true;
                    console.error(error);
                });
    }

    assignData(data: any): any {

        if (data.distributorId == this.tempData[0].distributorId) {
            data.children = this.tempData[0].children;
        }
        else if (data.children && data.children.length > 0) {
            data.children.forEach((element: any) => {
                element = this.assignData(element)
            });
        }

        return data;
    }

    openHierarchy(selected: any) {
        let searchIdList: any = [];
        let found = false;
        this.isSearchTextAvailable = true;
        this.selectedDistributorName = selected.name;
        this.isScrollToSearch = true;
        searchIdList = selected.distributors;
        this.downlineIds = searchIdList.reverse();
        this.treeData[0].children.forEach((ele: any) => {
            if (this.downlineIds.length > 0) {
                if (this.downlineIds.indexOf(ele.distributorId) > -1) {
                    if (ele.hasDownLine && ele.children.length == 0) {
                        this._commonService.getSearchMemberDetails(this.downlineIds, this.country.substring(0, 3))
                            .subscribe((res: any) => {
                                res === null ? [] : res;

                                if (res && res[0].children.length > 0) {
                                    ele.children = res[0].children;
                                }
                                this.drawCollapisibleTree(res[0]);
                                this.isSearchTextAvailable = false;
                            },
                                (error: any) => {
                                    this.errormessage = true;
                                    console.error(error);
                                });
                    }
                }
            }
            else {
                this.drawCollapisibleTree();
                this.isSearchTextAvailable = false;
                // this._loader.hide();
            }
        });
    }

    setDefaultPaymentPic(): void {
        if (!environment.production) {
            this.profilePicUrl = environment.uiTemplateBaseUrl + '/images/nobody_m.original.jpg';
        } else {
            this.profilePicUrl = environment.uiTemplateBaseUrl + '/images/no_image.png';
        }
    }
    drawCollapisibleTree(d?: any) {
        let count = this.treeData[0].children.length > 0 ? this.treeData[0].children.length : 4;
        let downlineMap = this;
        var margin = { top: 50, right: 90, bottom: 30, left: 90 },
            width = 890 - margin.left - margin.right,
            height = (count * 25) < 1000 ? 500 : count * 25;
        var oldHeight = 0;
        var oldWidth = 0;
        var svg;
        var i = 0, duration = 50;
        var root: any;
        var treemap;
        var _zoom;
        const svgSelector = "#tree" + this.fboid;
        d3.select(svgSelector+" svg").remove();
        svg = d3.select(svgSelector).append("svg")

        prepareTreeData();
        createSvg();
        function prepareTreeData() {
            let copyTreeData: any = downlineMap.treeData;

            root = d3.hierarchy(copyTreeData[0], function (d) { return d.children; });
            root.x0 = height / 2;
            root.y0 = 0;

            if (root && root.children && root.children.length > 0) {
                root.children.forEach((d: any) => { collapse(d) });
            }
        }
        update(root);
        function createSvg() {
            if (oldHeight != height) {
                svg.selectAll("g").remove();

                svg.attr("width", width + margin.right + margin.left)
                    .attr("height", height + margin.top + margin.bottom)
                    .append("g")
                    .attr("transform", "translate("
                        + margin.left + ",20)");
                treemap = d3.tree().size([height, width]);

                _zoom = d3.zoom()
                    .scaleExtent([1 / 2, 6])
                    .on("zoom", function () {
                        svg.select("g").transition()
                            .duration(50)
                            .attr("transform", d3.event.transform);
                    });


                oldHeight = height;
                oldWidth = width;
            }
        }
        function collapse(d: any) {
            if (d.children) {
                if (downlineMap.downlineIds && downlineMap.downlineIds.length > 0) {
                    if (downlineMap.downlineIds.indexOf(d.data.distributorId) == -1) {
                        d._children = d.children;
                        d.children = null;
                        if (d._children && d._children.length > 0) {
                            d._children.forEach(collapse)
                        }
                    }
                    else {
                        if (d.children && d.children.length > 0 && !(d.data.distributorId == downlineMap.id)) {
                            d.children.forEach(collapse)
                        }
                        if (d.data.distributorId == downlineMap.id) {
                            downlineMap.updatedEvent = d.children
                        }
                    }
                }
            }
        }
        function calcHeight(): any {
            let maxHeight = 0;
            let maxDepth = 0;
            let flag = 0;
            let maxCount: Array<any> = [{ level: 0, count: 0 }];
            let treeData = treemap(root);

            var nodes = treeData.descendants(),
                links = treeData.descendants().slice(1);

            if (nodes && nodes.length > 0) {

                nodes.forEach(function (d) {
                    maxCount.forEach((element: any) => {
                        if (d.depth == element.level) {
                            flag = 1;
                        }
                    });
                    if (flag != 1) {
                        maxCount.push({ level: d.depth, count: 1 });
                    }
                    else {
                        maxCount.forEach((ele: any) => {
                            if (ele.level == d.depth) {
                                ele.count++;
                            }
                        });
                        flag = 0;
                    }
                    d.y = d.depth * 250;
                });
                maxHeight = Math.max.apply(Math, maxCount.map(function (o) { return o.count; }))
                width = (nodes[0].height * 260) + 890 - margin.left - margin.right;
                if (maxHeight > 1) {
                    height = maxHeight * 35;
                }
                else {
                    height = 120;
                }
            }
        }
        function click(d: any) {
            downlineMap.isDetailsOpened = false;
            if (d.data.profileUrl == "" || d.data.profileUrl == null) {
                downlineMap.profile = {
                    url: downlineMap.noImageUrl,
                    name: d.data.name,
                    level: d.data.memberLevel,
                    id: d.data.distributorId,

                    contact: { email: d.data.email, mobile: d.data.phone }
                };
                downlineMap.profilePicUrl = downlineMap.profile.url;
                downlineMap.distributorId = downlineMap.profile.id;
            }
            else {
                downlineMap.profile = {
                    url: d.data.profileUrl,
                    name: d.data.name,
                    level: d.data.memberLevel,
                    id: d.data.distributorId,
                    contact: { email: d.data.email, mobile: d.data.phone }
                };
                downlineMap.profilePicUrl = downlineMap.profile.url;
                downlineMap.distributorId = downlineMap.profile.id;
            }

            downlineMap.id = d.data.distributorId;
            if (downlineMap.downlineIds.indexOf(d.data.distributorId) == -1) {
                downlineMap.downlineIds.push(d.data.distributorId);
            }
            if (d.data.hasDownLine && d.data.children.length == 0) {
                let countryCode = d.data.country && d.data.country !== "" ? d.data.country.substring(0, 3) : downlineMap.userInfo['homeCountryCode'];
                if (d.data.distributorId !== downlineMap.fboid) {
                    downlineMap.verticalTreeRequest = downlineMap._commonService
                        .getVerticalTree(d.data.distributorId, downlineMap.country, 0, null, null, false)
                        .subscribe((res: any) => {
                            downlineMap.tempData = res === null ? [] : res;
                            if (downlineMap.tempData[0].children && downlineMap.tempData[0].children.length > 0) {
                                downlineMap.treeData[0].children.forEach((element: any) => {
                                    element = downlineMap.assignData(element);
                                });
                                prepareTreeData();
                                d._children = downlineMap.updatedEvent;
                                calcHeight();
                                createSvg();
                                click(d);
                            }
                        },
                            (error: any) => {
                                this.errormessage = true;
                                console.error(error);
                            });
                }
            }
            else {
                if (d.children) {
                    downlineMap.downlineIds.splice(downlineMap.downlineIds.indexOf(d.data.distributorId), 1)
                    d._children = d.children;
                    d.children = null;

                } else {
                    d.children = d._children;
                    d._children = null;
                }
                calcHeight();
                createSvg();
                update(d);
                // downlineMap._loader.hide();
            }

        }

        function resetted() {
            svg.transition()
                .duration(50)
                .call(_zoom.transform, d3.zoomIdentity); //.translate((totalDepth == 0?200:totalDepth*400),(totalDepth == 0?200:totalDepth* 400) )
        }

        function diagonal(s: any, d: any) {
            let path = `M ${s.y} ${s.x}
            C ${(s.y + d.y) / 2} ${s.x},
              ${(s.y + d.y) / 2} ${d.x},
              ${d.y + 18} ${d.x}`
            return path
        }

        function UpdatePersonalDetails(d: any) {
            if (downlineMap.searchText) {
                if (d.profileUrl == "" || d.profileUrl == null) {
                    downlineMap.profile = {
                        url: downlineMap.noImageUrl,
                        name: d.name,
                        level: d.memberLevel,
                        id: d.distributorId,
                        contact: { email: d.email, mobile: d.phone }
                    };
                    downlineMap.profilePicUrl = downlineMap.profile.url;
                    downlineMap.distributorId = downlineMap.profile.id;
                }
                else {
                    downlineMap.profile = {
                        url: d.profileUrl,
                        name: d.name,
                        level: d.memberLevel,
                        id: d.distributorId,
                        contact: { email: d.email, mobile: d.phone }
                    };
                    downlineMap.profilePicUrl = downlineMap.profile.url;
                    downlineMap.distributorId = downlineMap.profile.id;
                }
            }


            downlineMap.id = d.distributorId;
            if (downlineMap.downlineIds.indexOf(d.distributorId) == -1) {
                downlineMap.downlineIds.push(d.distributorId);
            }
            d.children = d.children == null ? 0 : d.children
            if (d.hasDownLine && d.children == 0) {
                let countryCode = d.country && d.country !== "" ? d.country.substring(0, 3) : downlineMap.userInfo['homeCountryCode'];
                downlineMap.verticalTreeRequest = downlineMap._commonService
                    .getVerticalTree(d.distributorId, downlineMap.country, 0, null, null, false)
                    .subscribe((res: any) => {
                        downlineMap.tempData = res === null ? [] : res;
                        if (downlineMap.tempData[0].children && downlineMap.tempData[0].children.length > 0) {
                            downlineMap.treeData[0].children.forEach((element: any) => {
                                element = downlineMap.assignData(element);
                            });
                            prepareTreeData();
                            d._children = downlineMap.updatedEvent;
                            calcHeight();
                            createSvg();
                        }
                        // downlineMap._loader.hide();
                    },
                        (error: any) => {
                            this.errormessage = true;
                            console.error(error);
                        });
            }
            else {
                if (d.children) {
                    downlineMap.downlineIds.splice(downlineMap.downlineIds.indexOf(d.distributorId), 1)
                    d._children = d.children;
                    d.children = null;

                } else {
                    d.children = d._children;
                    d._children = null;
                }
                calcHeight();
                createSvg();
                update(d);
                // downlineMap._loader.hide();
            }
            // downlineMap._loader.hide();
        }

        function update(source: any) {
            let maxCount: Array<any> = [{ level: 0, count: 0 }];
            let treeData = treemap(root);
            let currentUser;
            if (source.data) {
                currentUser = source.data.name;
            }
            else {
                currentUser = source.name;
            }

            var nodes = treeData.descendants(),
                links = treeData.descendants().slice(1);
            if (nodes && nodes.length > 0) {
                nodes.forEach(function (d) {
                    d.y = d.depth * 250;
                    downlineMap.globalLeftOffset = d.y;
                });
            }

            var node = svg.select("g").selectAll('g.node')
                .data(nodes, function (d: any) { return d.id || (d.id = ++i); });

            var nodeEnter = node.enter().append('g')
                .attr('class', 'node')
                .attr("transform", function (d) {
                    return "translate(" + source.y0 + "," + source.x0 + ")";
                })
                .on('click', click);

            nodeEnter.append('circle')
                .attr('class', 'node')
                .attr('r', 1e-6)
                .style("stroke-width", "2px")
                .style("stroke", function (d: any) {
                    if (d.data.level == DownlineMemberLevel.ASSISTANT_SUPERVISOR || d.level == DownlineMemberLevel.ASSISTANT_SUPERVISOR || d.data.memberLevel == DownlineMemberLevel.ASSISTANT_SUPERVISOR) {
                        return "teal";
                    }
                    else if (d.data.level == DownlineMemberLevel.SUPERVISOR || d.level == DownlineMemberLevel.SUPERVISOR || d.data.memberLevel == DownlineMemberLevel.SUPERVISOR ) {
                        return "rgb(115, 185, 9)";
                    }
                    else if (d.data.level == DownlineMemberLevel.ASSISTANT_MANAGER || d.level == DownlineMemberLevel.ASSISTANT_MANAGER || d.data.memberLevel == DownlineMemberLevel.ASSISTANT_MANAGER) {
                        return "rgb(226, 110, 15)";
                    }
                    else if (d.data.level == DownlineMemberLevel.NOVUS_CUSTOMER || d.level == DownlineMemberLevel.NOVUS_CUSTOMER || d.data.memberLevel == DownlineMemberLevel.NOVUS_CUSTOMER) {
                        return "rgba(6, 50, 117, 0.87)";
                    }
                    else {
                        return "rgb(155, 14, 56)";
                    }
                })

            nodeEnter.append('text')
                .attr("dy", ".35em")
                .attr("x", 13)
                .attr("text-anchor", "start")
                .style("font-weight", function (d: any) {
                    return d.data.name.replace(",","") == downlineMap.selectedDistributorName ? "bold" : "normal"
                })
                .text(function (d: any) { return d.data.name; });
            var nodeUpdate = nodeEnter.merge(node);

            nodeUpdate.transition()
                .duration(duration)
                .attr("transform", function (d: any, i) {
                    if (d.data.name == downlineMap.selectedDistributorName && downlineMap.isScrollToSearch == true) {
                        downlineMap.globalTopOffset = d.x;
                        this.isScrollToSearch = false;
                    } else
                        if (currentUser == d.data.name) {
                            downlineMap.globalTopOffset = d.x;
                        }
                    return "translate(" + (d.y + 10) + "," + (d.x) + ")";
                });

            nodeUpdate.select('circle.node')
                .attr('r', 6.5)
                .style("fill", function (d: any) {
                    if (d.data.level == DownlineMemberLevel.ASSISTANT_SUPERVISOR || d.level == DownlineMemberLevel.ASSISTANT_SUPERVISOR 
                     || d.data.memberLevel == DownlineMemberLevel.ASSISTANT_SUPERVISOR) {
                        return d.data.hasDownLine ? "teal" : "rgb(255, 255, 255)";
                    }
                    else if (d.data.level == DownlineMemberLevel.SUPERVISOR || d.level == DownlineMemberLevel.SUPERVISOR || d.data.memberLevel == DownlineMemberLevel.SUPERVISOR) {
                        return d.data.hasDownLine ? " rgb(115, 185, 9)" : "rgb(255, 255, 255)";
                    }
                    else if (d.data.level == DownlineMemberLevel.ASSISTANT_MANAGER || d.level == DownlineMemberLevel.ASSISTANT_MANAGER || d.data.memberLevel == DownlineMemberLevel.ASSISTANT_MANAGER) {
                        return d.data.hasDownLine ? "rgb(226, 110, 15)" : "rgb(255, 255, 255)";
                    }
                    else if (d.data.level == DownlineMemberLevel.NOVUS_CUSTOMER || d.level == DownlineMemberLevel.NOVUS_CUSTOMER || d.data.memberLevel == DownlineMemberLevel.NOVUS_CUSTOMER) {
                        return d.data.hasDownLine ? "rgba(7, 43, 99, 0.87)" : "rgb(255, 255, 255)";
                    }
                    else {
                        return d.data.hasDownLine ? "rgb(155, 14, 56)" : "rgb(255, 255, 255)";
                    }
                })
                .attr('cursor', 'pointer');

            var nodeExit = node.exit().transition()
                .duration(duration)
                .attr("transform", function (d) {
                    return "translate(" + source.y + "," + source.x + ")";
                })
                .remove();

            nodeExit.select('circle')
                .attr('r', 1e-6);
            nodeExit.select('text')
                .style('fill-opacity', 1e-6);
            var link = svg.select("g").selectAll('path.link')
                .data(links, function (d: any) { return d.id; });

            var linkEnter = link.enter().insert('path', "g")
                .attr("class", function (d) {
                    return "link";
                })
                .attr('d', function (d) {
                    var o = { x: source.x0, y: source.y0 }
                    return diagonal(o, o)
                });
            var linkUpdate = linkEnter.merge(link);

            linkUpdate.transition()
                .duration(duration)
                .attr('d', function (d) { return diagonal(d, d.parent) });

            var linkExit = link.exit().transition()
                .duration(duration)
                .attr('d', function (d) {
                    var o = { x: source.x, y: source.y }
                    return diagonal(o, o)
                })
                .remove();

            // if (downlineMap.searchText && downlineMap.isSearchTextAvailable) { UpdatePersonalDetails(d); }

            nodes.forEach(function (d: any) {
                d.x0 = d.x;
                d.y0 = d.y;
            });

            svg.call(_zoom);

            var zp = d3.select("#zp");
            zp
                .on("click", function () {
                    _zoom.scaleBy(svg, 1.05);
                });

            var zm = d3.select("#zm");
            zm
                .on("click", function () {
                    _zoom.scaleBy(svg, 0.95);
                });

            var zr = d3.select("#zr")
                .on("click", resetted)

            // downlineMap._loader.hide();
            // $('#tree').animate({scrollTop: 0, scrollLeft: 0}, 'fast'); 
            // $('#tree').animate({ scrollTop: downlineMap.globalTopOffset - 200, scrollLeft: downlineMap.globalLeftOffset - 100 }, 'slow');
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/customerservice/components/downline-map.component.ts